import styled from 'styled-components';

export const Container = styled.div`
  ul {
    list-style: none;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
    }
  }

  p {
    font-weight: bold;
    margin-bottom: 16px;
  }

  @media (max-width: 768px) {
    flex-direction: column;

    .d-flex {
      display: grid !important;
    }

    .mapa-brasil,
    .lista-estados {
      display: block;
      width: 100%;
      margin-right: 0;
    }

    .mapa-brasil {
      order: 1;
      margin-bottom: 20px;
    }

    .lista-estados {
      order: 2;
    }
  }
`;
